(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ibey-shipping-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ibey-offer')) {
 customElements.define('ibey-offer', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();this.controller=new AbortController();
   this.querySelector('button').addEventListener('click',async event=>{
    const button=event.currentTarget;
    try {await navigator.clipboard.writeText(button.dataset.code);this.querySelector('[aria-live]').textContent=button.dataset.copied;button.querySelector('[data-copy-label]').textContent=button.dataset.copied;}
    catch {this.querySelector('[aria-live]').textContent=button.dataset.failed;}
   },{signal:this.controller.signal});
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ibey-tiered-offers"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ibey-tiered-offers')){
 customElements.define('ibey-tiered-offers',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();
   this.querySelectorAll('[data-code]').forEach(button=>{
    button.addEventListener('click',async()=>{
     const label=button.querySelector('[data-code-label]');
     try{
      await navigator.clipboard.writeText(button.dataset.code);
      this.querySelector('[aria-live]').textContent=button.dataset.copied+' '+button.dataset.code;
      label.textContent=button.dataset.copied;
      clearTimeout(button.resetTimer);button.resetTimer=setTimeout(()=>{label.textContent=button.dataset.code},1800);
     }catch{this.querySelector('[aria-live]').textContent=button.dataset.failed}
    },{signal:this.controller.signal});
   });
  }
  disconnectedCallback(){this.controller?.abort();this.querySelectorAll('[data-code]').forEach(b=>clearTimeout(b.resetTimer))}
 });
}
  } catch(e) { console.error(e); }
})();

})();
